"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owners = [
    {
        id: 1,
        title: 'Один',
    },
    {
        id: 2,
        title: 'Два',
    },
    {
        id: 3,
        title: 'Три и больше'
    }
];
var getAvailableOwners = function () {
    return owners;
};
exports.default = getAvailableOwners;
